import { updateRequestContants } from "../constant/updateRequest.contants";
import { updatRequestService } from "../services/updateRequest.service";
import CONSTANT from "../constant/constant";
import functionCommon from "../common/function";

const _errorCode = CONSTANT.errorCode;

export const updateRequest = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return (dispatch) => {
        updatRequestService.update(data).then((res) => {
            if (!res) return;
            switch (res["http_code"]) {
                case _errorCode.APIUpdatedSuccess:
                    dispatch(success("004"));
                    break;
                case _errorCode.APIDuplicate:
                    dispatch(failure(res["error_code"]));
                    break;

                case _errorCode.TOKENExpired:
                    functionCommon.logout();
                    break;

                case _errorCode.APIInvalids:
                    functionCommon.logout();
                    break;

                case _errorCode.DBCanNotConnect:
                    window.location = "/error/404";
                    break;

                case _errorCode.ClientNotPermission:
                    functionCommon.logout();
                    break;

                default:
                    dispatch(failure(res["error_code"]));
                    window.location = "/error/404";
                    break;
            }
        });
    };

    function success(code) {
        return { type: updateRequestContants.UPDATE_SUCCESS, code };
    }
    function failure(code) {
        return { type: updateRequestContants.UPDATE_FAILURE, code };
    }
};

export const deleteError = () => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return (dispatch) => {
        dispatch(deleleErrorCode());
    };
    function deleleErrorCode() {
        const code = "";
        return { type: updateRequestContants.UPDATE_SUCCESS, code };
    }
};
